import type * as React from "react";
import { cn } from "~/lib/utils";

type SectionProps = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  backgroundClassName?: string;
};

export function Section({
  id,
  children,
  className,
  containerClassName,
  backgroundClassName,
}: SectionProps) {
  return (
    <section
      id={id}
      className={cn("px-6 py-20 sm:px-10", backgroundClassName, className)}
    >
      <div className={cn("mx-auto max-w-[1080px]", containerClassName)}>
        {children}
      </div>
    </section>
  );
}
